import { PortalModule, PortalRouteConfig } from "@isocial-vue/blueprint";
import _ from "lodash" //forces use latest version from instance
console.log("lodash version: "+_.VERSION); //forces use latest version from instance

// Sub routing
export interface RTWPRoutesConfiguration {
  rootRouteName: string;
}

export function buildRTWPRoutes(configuration: RTWPRoutesConfiguration): PortalRouteConfig[] {
  return [
    {
      path: "/",
      name: configuration.rootRouteName,
      component: () => import("./views/Home.vue"),
      auth: { allowAnonymous: true },
    },
    {
      path: "/form",
      name: "Form-BE",
      component: () => import("./views/form/BE.vue"),
      auth: { allowAnonymous: false },
    },
    {
      path: "/form-int",
      name: "Form-INT",
      component: () => import("./views/form/INT.vue"),
      auth: { allowAnonymous: true },
    },
    {
      path: "/logged-off", //reroute to home, nothing special to do in this app
      beforeEnter: async (to, from, next) => next("/"),
      auth: { allowAnonymous: true },
    },
  ];
}

// Main routing
const config: RTWPRoutesConfiguration = {
  rootRouteName: "RTWP",
};

export const module = {
  name: "rtwp",
  routes: buildRTWPRoutes(config),
  supportedLocales: ["fr", "nl", "de"],
} as PortalModule;
